import { Image, Space, Typography } from 'antd';
import React from 'react';

interface ImageCardProps {
  title: string;
  description: string;
  icon: string;
}

const ImageCard = function ({ title, description, icon }: ImageCardProps) {
  return (
    <Space orientation="vertical" size={8}>
      <Image
        src={`https://cdn.guuru.com/assets/pages/invitation/howitworks/${icon}`}
        width={86}
        preview={false}
      />
      <Space orientation="vertical" size={2}>
        <Typography.Title level={5}>{title}</Typography.Title>
        <Typography.Text type="secondary">{description}</Typography.Text>
      </Space>
    </Space>
  );
};

export default ImageCard;
